import httpClient from "../httpClient";

const END_POINT = '/site'

const getSites = () => httpClient.get(`${END_POINT}/all`);
const getUserSites = () => httpClient.get(END_POINT)
const getSiteById = (id) => httpClient.get(`${END_POINT}/${id}`)
const createSite = (site) => httpClient.post(END_POINT, site)
const updateSite = (id, site) => httpClient.put(`${END_POINT}/${id}`, site)
const updateSiteToken = (id) => httpClient.post(`${END_POINT}/update-token/${id}`);

export {
  getSites,
  getUserSites,
  getSiteById,
  createSite,
  updateSite,
  updateSiteToken
};